// extracted by mini-css-extract-plugin
export default {"Errors":"components-Login-Errors-_Errors-module_Errors","errors":"components-Login-Errors-_Errors-module_Errors","title":"components-Login-Errors-_Errors-module_title"};